import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import type { OrderAlert } from '../../../Model/Order/orderAlerts.ts'

/** A warning sign next to the order name that opens the order's alerts; nothing when it has none. */
export const OrderAlertIndicator = ({ alerts }: { alerts: OrderAlert[] }) => {
  if (alerts.length === 0) {
    return null
  }
  const anyOpen = alerts.some((alert) => !alert.resolved)

  return (
    <div className="dropdown dropdown-bottom dropdown-end ml-2" data-testid="order-alerts">
      <div
        tabIndex={0}
        role="button"
        className={`btn btn-ghost btn-sm px-1 ${anyOpen ? 'text-amber-500' : 'text-gray-400'}`}
        aria-label={`${alerts.length} notice(s) on this order`}
      >
        <ExclamationTriangleIcon className="w-6 h-6" />
      </div>
      <div tabIndex={0} className="dropdown-content z-20 card card-compact w-96 max-w-[90vw] bg-base-100 shadow-lg border border-amber-200">
        <div className="card-body">
          <h3 className="font-semibold text-base">Notices on this order</h3>
          <ul className="divide-y">
            {alerts.map((alert) => (
              <li key={alert.id} className={`py-2 ${alert.resolved ? 'text-gray-400' : ''}`}>
                <p className="font-medium text-sm">
                  {alert.title}
                  {alert.resolved && <span className="ml-2 text-xs">resolved</span>}
                  {alert.audience && <span className="badge badge-ghost badge-sm ml-2">{alert.audience}</span>}
                </p>
                <p className="text-sm whitespace-pre-wrap mt-1">{alert.body}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
